export default [
  {
    path: '/groups',
    name: 'groups',
    component: () => import('@/views/marketing/groups/pages/GroupsList.vue'),
    meta: {
      resource: 'groups',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Groups',
      breadcrumb: [
        {
          text: 'Groups',
          active: true,
        },
      ],
    },
  },
  {
    path: '/create-group',
    name: 'create-group',
    component: () => import('@/views/marketing/groups/pages/CreateGroup.vue'),
    meta: {
      resource: 'groups',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Groups',
      breadcrumb: [
        {
          text: 'Groups',
          to: '/groups',
        },
      ],
    },
  },
  {
    path: '/edit-group/:id',
    name: 'edit-group',
    component: () => import('@/views/marketing/groups/pages/CreateGroup.vue'),
    meta: {
      resource: 'groups',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Edit Group',
      breadcrumb: [
        {
          text: 'Groups',
          to: '/groups',
        },
        {
          text: 'Edit Group',
          active: true,
        },
      ],
    },
  },
]
